import { Dispatch, FC, memo, SetStateAction, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ICampusItem } from '../models/campuses.model';
import { RootState } from '../store/rootReducer';

interface IProps {
  height?: string;
  level?: number;
  coord?: string[]|undefined;
  address?: string|undefined;
  stations?: any;
  sidoCode?: string|undefined;
  campuses?: ICampusItem[]|undefined;
  useMapSetting?: boolean;
  setUseMapSetting?: (useMapSetting: boolean) => void;
}

const Map: FC<IProps> = ({
  height = '600px',
  level = 5,
  coord,
  address,
  stations,
  sidoCode,
  campuses,
  useMapSetting = false,
  setUseMapSetting
}) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0004 = 지역
  const SY0004 = commonCodes.find(item => item.commonCode === 'SY0004')?.detailCode;

  const { kakao } = window;
  let map: any = null;

  useEffect(() => {
    setMap();
  }, [coord, address, sidoCode, campuses]);

  useEffect(() => {
    if (!useMapSetting || !setUseMapSetting) return;

    setMap();

    setUseMapSetting(false);
  }, [useMapSetting]);

  const setMap = () => {
    const container = document.querySelector('#map');
    const options = {
      center: new kakao.maps.LatLng('37.56642510458935', '126.97794052669803'),
      level
    };
    try {
      map = new kakao.maps.Map(container, options);
    } catch (e) {
      alert(e);
    }

    // 확대/축소 컨트롤
    const zoomControl = new kakao.maps.ZoomControl();
    map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);    

    if (coord && coord.length > 0) {
      renderMarker(coord[0], coord[1]);
      setCenter(coord[0], coord[1]);
    }
    
    if (address || sidoCode) {
      if (sidoCode) {
        const sido = SY0004?.find(item => item.detailCode === sidoCode);
        address = sido?.korName;
      }

      const geocoder = new kakao.maps.services.Geocoder();
      geocoder.addressSearch(address, (result: any, status: any) => {
        if (status === kakao.maps.services.Status.OK) {
          setCenter(result[0].y, result[0].x);
        }
      });
    }

    if (stations) {
      const coords: any = [];
      stations.forEach((item: any) => {
        renderMarker(item.latitude, item.longitude);
        coords.push({ lat: item.latitude, lng: item.longitude });
      });
      renderLine(coords);
    }

    if (campuses) {
      console.log('campuses', campuses)
      campuses.forEach(item => {
        if (item.address) {
          const geocoder = new kakao.maps.services.Geocoder();
          geocoder.addressSearch(item.address, (result: any, status: any) => {
            if (status === kakao.maps.services.Status.OK) {
              renderMarker(result[0].y, result[0].x, item.campusKorName);
            }
          });
        }
        if (item.regions) {
          renderPolygon(item.regions);
        }
      });
    }
  }

  const setCenter = (lat: string, lng: string) => {
    const position = new kakao.maps.LatLng(lat, lng);
    map.setCenter(position);
  }

  const renderMarker = (lat: string, lng: string, title: string = '') => {
    const position = new kakao.maps.LatLng(lat, lng);
    new kakao.maps.Marker({ map, position, title });
  }

  const renderLine = (coords: any) => {
    const path: any = [];
    coords.forEach((coord: any) => path.push(new kakao.maps.LatLng(coord.lat, coord.lng)));
    const polyline = new kakao.maps.Polyline({
      path,
      strokeWeight: 5,
      strokeColor: '#ff3de5',
      strokeOpacity: 0.5,
      strokeStyle: 'solid'
    });
    polyline.setMap(map);    
  }
  
  const renderPolygon = (coords: any) => {
    console.log('coords', coords);
    const path: any = [];
    coords.forEach((coord: any) => path.push(new kakao.maps.LatLng(coord.latitude, coord.longitude)));
    const polygon = new kakao.maps.Polygon({
      map,
      path,
      fillColor: '#CFE7FF',
      fillOpacity: 0.5
    });
    polygon.setMap(map);
  }

  return (
    <>      
      <div id="map" style={{ height }} />
    </>
  )
}

export default memo(Map);
